export async function getBitchuteVideoUrl(videoId: string): Promise<string> {
    const encodedId = encodeURIComponent(videoId);
    const response = await fetch(`https://www.bitchute.com/api/beta9/embed/${encodedId}?videoID=${encodedId}`);
    if (!response.ok) {
        throw new Error(`BitChute embed request failed (HTTP ${response.status}).`);
    }

    const html = await response.text();
    const mediaUrl = html.match(/\bvar\s+(?:media_url|mediaUrl)\s*=\s*(['"])(https?:\/\/[^'"\s]+)\1/)?.[2];
    if (!mediaUrl) {
        throw new Error("BitChute did not provide a direct video URL. The video may be unavailable.");
    }

    return mediaUrl;
}
